/**
 * IM消息列表
 * author: jiaheming
 * date: 2019/06/12
 */
import { produce } from 'immer';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import config from '../../config';
import util from '../../utils';
import IMEmpty from './IMEmpty';
import IMFooter from './IMFooter';
import IMItem from './IMItem';

const IMListStyle = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    .im-list-container {
        width: 100%;
        height: 100%;
        flex: auto;
        overflow-x: hidden;
    }
`;

class IMList extends React.Component {
    render() {
        let list = this.props.sessionlist || [];

        let userInfos = this.props.userInfos;

        let myInfo = this.props.myInfo;

        let myPhoneId = `${this.props.myPhoneId}`;
        let sessionlist = produce(list, draft => {
            draft.filter(item => {
                item.name = '';
                item.avatar = '';
                if (item.scene === 'p2p') {
                    let userInfo = null;
                    if (item.to !== myPhoneId) {
                        userInfo = userInfos[item.to];
                    } else {
                        userInfo = myInfo;
                        userInfo.alias = myInfo.nick;
                        userInfo.avatar = myInfo.avatar; // `${config.myPhoneIcon}`
                        // return false
                    }
                    if (userInfo) {
                        item.name = util.getFriendAlias(userInfo);
                        item.avatar = userInfo.avatar;
                    }
                }
                /* else if (item.scene === 'team') {
                        let teamInfo = null
                        teamInfo = this.props.imStore.teamlist.find(team => {
                            return team.teamId === item.to
                        })
                        if (teamInfo) {
                            item.name = teamInfo.name
                            item.avatar = teamInfo.avatar || (teamInfo.type === 'normal' ? this.myGroupIcon : this.myAdvancedIcon)
                        } else {
                            item.name = `群${item.to}`
                            item.avatar = item.avatar || this.myGroupIcon
                        }
                    } */
                let lastMsg = item.lastMsg || {};
                if (lastMsg.type === 'text') {
                    item.lastMsgShow = lastMsg.text || '';
                } else if (lastMsg.type === 'custom') {
                    item.lastMsgShow = util.parseCustomMsg(lastMsg);
                } else if (lastMsg.scene === 'team' && lastMsg.type === 'notification') {
                    item.lastMsgShow = util.generateTeamSysmMsg(lastMsg);
                } else if (util.mapMsgType(lastMsg)) {
                    if (util.mapMsgType(lastMsg) === '未知消息类型') {
                        item.lastMsgShow = '';
                    } else {
                        item.lastMsgShow = `[${util.mapMsgType(lastMsg)}]`;
                    }
                } else {
                    item.lastMsgShow = '';
                }
                if (item.updateTime) {
                    item.updateTimeShow = util.formatDate(item.updateTime, true);
                }
                return item;
            });
        });
        return (
            <IMListStyle>
                <div className="im-list-container">
                    {sessionlist instanceof Array && sessionlist.length > 0 ? (
                        sessionlist.map((session, index) => {
                            return (
                                <IMItem
                                    key={session.id}
                                    session={session}
                                    userInfo={userInfos[session.to] || null}
                                    switchSessionCallback={this.props.switchSessionCallback}
                                />
                            );
                        })
                    ) : (
                        <IMEmpty>{this.props.emptyComponent}</IMEmpty>
                    )}
                </div>
                <IMFooter />
            </IMListStyle>
        );
    }
}

function mapStateToProps(store) {
    const { imStore } = store[config.reduxStoreName];
    const { sessionlist, userInfos, userUID, myInfo } = imStore;
    return { sessionlist, userInfos, myPhoneId: userUID, myInfo };
}

export default connect(mapStateToProps)(IMList);
